import { render, staticRenderFns } from "./chartComponent6.vue?vue&type=template&id=ff2baccc&scoped=true&"
import script from "./chartComponent6.vue?vue&type=script&lang=js&"
export * from "./chartComponent6.vue?vue&type=script&lang=js&"
import style0 from "./chartComponent6.vue?vue&type=style&index=0&id=ff2baccc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2baccc",
  null
  
)

export default component.exports